<script setup lang="ts">
import type { VChip } from 'vuetify/components';

type PropsType = {
    color?: string;
    variant?: VChip['$props']['variant'];
    size?: VChip['$props']['size'];
};

withDefaults(defineProps<PropsType>(), {
    color: 'primary',
    variant: 'flat',
    size: 'default',
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VChip
        :color="color"
        :variant="variant"
        :size="size"
        v-bind="$attrs"
    >
        <template
            v-if="$slots.prepend"
            #prepend
        >
            <slot name="prepend" />
        </template>

        <slot />

        <template
            v-if="$slots.append"
            #append
        >
            <slot name="append" />
        </template>
    </VChip>
</template>
